import styled from 'styled-components';

const LogoWrapper = styled.div`
	display: flex;
	cursor: pointer;
	width: 200px;
`;

export default {
	LogoWrapper
};
